import React, { PureComponent } from "react";
import Link from "next/link";
import dayjs from "dayjs";
import ReportUserButton from "../report-user-button/report-user-button";
import MiniMenu from "../mini-menu/mini-menu";
import ProfilePic from "../profile-pic/profile-pic";

import "./post-details.scss";

class PostDetails extends PureComponent {
  render() {
    const { me, type, poster, createdAt, itemId } = this.props;

    const isMyPost = me && me.id === poster.id;

    return (
      <div className="post-details">
        <div className="post-details__inner">
          <MiniMenu modifierClass={"post-details__options"} minWidth="165px">
            <ReportUserButton
              copy={`Report this ${
                type === "QUESTION" ? "question" : "answer"
              } as spam or inappropriate`}
              userId={poster.id}
              reportedFrom={type}
              relevantItemId={itemId}
            />
          </MiniMenu>
          <div className="post-details__title">{`${
            type === "QUESTION" ? "Asked by:" : "Answered by:"
          }`}</div>
          <div className="post-details__poster">
            <Link href="/profile/[id]" as={`/profile/${poster.id}`}>
              <a>
                <div className="post-details__poster__firstname">
                  {isMyPost ? "You" : poster.firstName}
                </div>
                <ProfilePic
                  width={20}
                  height={20}
                  profilePic={poster.profilePic}
                />
              </a>
            </Link>
          </div>
          <div className="post-details__created-at">
            {`On: `}
            {dayjs(createdAt).format("DD/MM/YYYY HH:mm")}
          </div>
        </div>
      </div>
    );
  }
}

export default PostDetails;
